/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostOrdersReportMutationResponse, PostOrdersReportQueryParams, PostOrdersReport400 } from "../entities/PostOrdersReport";

function getPostOrdersReportUrl() {
  const res = { method: 'POST', url: `/orders/report` as const }  
  return res
}

/**
 * @description Получение отчета по поездкам Dostavkee
 * @summary Получение отчета по поездкам Dostavkee
 * {@link /orders/report}
 */
export async function postOrdersReport(params: PostOrdersReportQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PostOrdersReportMutationResponse, ResponseErrorConfig<PostOrdersReport400>, unknown>({ method : "POST", url : getPostOrdersReportUrl().url.toString(), params, ... requestConfig })  
  return res.data
}